export default function ScenesPage() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Scenes</h1>
      <p>Manage your scenes here.</p>
    </div>
  );
}
